function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader!../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-25c7f483\",\"scoped\":false,\"hasInlineConfig\":false}!sass-loader!../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue")
}
var Component = require("!../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue"),
  /* template */
  require("!!../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-25c7f483\"}!../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/App.vue
// module id = 9
// module chunks = 0